import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 260,
    maxWidth: 260,
    height: 240,
    margin: 'auto',
    borderRadius: '50px 50px 0px 0px',
    boxShadow: '0 3px 11px rgb(0 0 0 / 16%)',
  },
  media: {
    height: '150px',
    position: 'relative',
  },
  overlay: {
    content: '',
    position: 'absolute',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    width: '100%',
    height: '100%',
    backgroundColor: '#000',
    zIndex: '1',
    display: 'block',
    opacity: '0.3',
    '&:hover': {
      opacity: '0.1',
      '- webkitTransition': 'opacity 0.5s ease-in -out',
      '- mozTransition': 'opacity 0.5s ease -in -out',
      'transition': 'opacity 0.5s ease -in -out',
    },
  },
  linkButton: {
    margin: 'auto',
    color: '#D62828',
    fontFamily: 'Gilroy-Light, serif',
    textTransform: 'capitalize',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }

}))




